/**
 * Confidence chip (Phase 3, §6.5). Colours a transfer candidate's match
 * confidence — emerald (sehr sicher) / amber (wahrscheinlich) / slate (unsicher)
 * — with the German label from `lib/labels.ts`. Colour is never the sole signal:
 * the text label always states the confidence.
 */
import { TRANSFER_CONFIDENCE } from '../../lib/labels.ts';
import type { TransferConfidence } from '../../lib/types.ts';

const STYLES: Record<TransferConfidence, string> = {
  high: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-300',
  medium: 'bg-amber-100 text-amber-800 dark:bg-amber-950 dark:text-amber-300',
  low: 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300',
};

export function ConfidenceChip({ confidence }: { confidence: TransferConfidence }) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${STYLES[confidence]}`}
    >
      {TRANSFER_CONFIDENCE[confidence]}
    </span>
  );
}
